/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_ApikeysInputs */

const en_settings_nav_apikeys = /** @type {(inputs: Settings_Nav_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

const zh_settings_nav_apikeys = /** @type {(inputs: Settings_Nav_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Settings_Nav_ApikeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_apikeys = /** @type {((inputs?: Settings_Nav_ApikeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_ApikeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_apikeys(inputs)
	return zh_settings_nav_apikeys(inputs)
});
export { settings_nav_apikeys as "settings.nav.apikeys" }